module.exports = __webpack_public_path__ + "img/CM-MC-25-Volvo-Established.1646da9b.jpg";